export default {
  circleO: '\f10c',
  circle: '\f111',
  powermode25: 'mode-25.svg',
  powermode50: 'mode-50.svg',
  powermode75: 'mode-75.svg',
  powermode100: 'mode-100.svg'
};
